import React, { createContext, useState } from "react";
import PropTypes from 'prop-types';

export const AdminFormContext = createContext();

export const AdminFormProvider = ({ children }) => {
    const [adminFormData, setAdminFormData] = useState({});

    return (
        <AdminFormContext.Provider value={{ adminFormData, setAdminFormData }}>
            {children}
        </AdminFormContext.Provider>
    );
};

AdminFormProvider.propTypes = {
    children: PropTypes.node.isRequired
};
